import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 停用物料。
 * `POST /mtr/{id}/deactivate`；body `{ updatedAt }`（不送 id）。
 *
 * @param {string} id
 * @param {{ updatedAt?: string }} [payload]
 */
export async function deactivateMtr(id, payload = {}) {
  const { data: raw } = await request.post(
    `/mtr/${id}/deactivate`,
    keysToSnake({ updatedAt: payload.updatedAt }),
  );
  return parseVer4DetailResponse(raw);
}
